export default "__VITE_ASSET__9d5c8b3c__"